import React from "react"
import { Platform, ScrollView } from "react-native"
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view"
import type { KeyboardAwareScrollViewProps } from "react-native-keyboard-aware-scroll-view"
import { useSafeAreaInsets } from "react-native-safe-area-context"

const KeyboardAvoidingScrollView = ({ children, ...props }: KeyboardAwareScrollViewProps) => {
  const { bottom } = useSafeAreaInsets()

  return Platform.OS === 'web' ? (
    <ScrollView
      {...props}
    >
      {children}
    </ScrollView>
  ) : (
    <KeyboardAwareScrollView
      // default props
      enableOnAndroid={true}
      extraScrollHeight={bottom * 2}
      // override props
      {...props}
    >
      {children}
    </KeyboardAwareScrollView>
  )
}

export default KeyboardAvoidingScrollView